import { Entity } from "../../common/entity";
import { ForgeProjectArtifact, ForgeSection, ProjectFeature, ForgeRelation, } from "../../forge";
import { z } from "zod";
export const ForgeProjectRoom = Entity.extend({
    projectId: z.string(),
    liveblocksId: z.string(),
});
export const ForgeProjectRoomInitialState = z.object({
    artifacts: z.array(ForgeProjectArtifact),
    features: z.array(ProjectFeature),
    artifactSections: z.array(ForgeSection),
    featureSections: z.array(ForgeSection),
    relations: z.array(ForgeRelation),
});
export const ForgeProjectRoomUpdate = z.object({
    artifacts: z.array(ForgeProjectArtifact).optional(),
    artifactIdsToDelete: z.array(z.string()).optional(),
    features: z.array(ProjectFeature).optional(),
    featureIdsToDelete: z.array(z.string()).optional(),
    artifactSections: z.array(ForgeSection).optional(),
    artifactSectionIdsToDelete: z.array(z.string()).optional(),
    featureSections: z.array(ForgeSection).optional(),
    featureSectionIdsToDelete: z.array(z.string()).optional(),
    relations: z.array(ForgeRelation).optional(),
    executedTransactionIds: z.string().array().optional(),
});
